import Section from "@/components/ui/section";
import React from "react";
import { m } from "framer-motion";
export default function Banner() {
  return (
    <Section className="bg-[#fafafa]">
      <m.div
        initial={{ y: 40, opacity: 0 }}
        whileInView={{ y: 0, opacity: 100 }}
        transition={{ duration: 0.75 }}
        className="flex flex-col items-center w-full mt-20"
      >
        {/* <p className="text-[#333333] uppercase">Our Clients</p> */}
        <h1 className="text-blue font-semibold text-center heading">
          <span className="text-lightBlue">Our</span> Clients
        </h1>
        <p className="text-center lg:max-w-[600px] !leading-normal mt-4">
          SoulScale is committed to providing exceptional services to
          organizations across various sectors. As a leading consultancy, we
          offer various specialized solutions to empower your success. Our
          services include comprehensive program management, impact assessment,
          research, documentation, monitoring and evaluation, CSR, CFO, and HR
          advisory services.
        </p>
      </m.div>
    </Section>
  );
}
